import React from 'react';
import './footer.css';

const footer = () => {
  return (
    <footer className='footer'>
        Copyright &#169; 2023 Vanessa Harmon. All rights reserved.
    </footer>
  )
}

export default footer
